// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bsbuuw1{width:200px}\n._4t3i11ux{height:140px}\n._otyrpxbi{margin-bottom:var(--ds-space-200,1pc)}", ""]);
// Exports
module.exports = exports;
